import { type MouseEvent as ReactMouseEvent } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@dynatrace/strato-components/buttons';
import { Text } from '@dynatrace/strato-components/typography';
import { CopyIcon } from '@dynatrace/strato-icons';

import { notificationMessages } from '../messages.js';

/**
 * The copy permissions button shown in the NotifyButton toast if the user doesn't have permissions to toggle notifications.
 * @internal
 */
export const CopyPermissionsButton = (
  props: Readonly<{ readOrWrite: 'read' | 'write' }>,
) => {
  const intl = useIntl();

  return (
    <Button
      variant="emphasized"
      onClick={(e: ReactMouseEvent) => {
        e.stopPropagation();
        navigator.clipboard.writeText(
          `notification:notifications:${props.readOrWrite}`,
        );
      }}
    >
      <Button.Prefix>
        <CopyIcon />
      </Button.Prefix>
      <Text textStyle="base-emphasized">
        {intl.formatMessage(notificationMessages.copyMissingPermissions)}
      </Text>
    </Button>
  );
};
